module.exports = __webpack_public_path__ + "static/media/icon-menu-down.4a3b507b.svg";